import SearchSelectDropdown from '@/components/search-select-dropdown/search-select-dropdown';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { Vue, Component, Prop, Watch, Inject, Provide } from 'vue-property-decorator';
import IndexContent from './index-content-loader';

@Component({
    name: 'data-in-form-tool',
    components: {
        'search-select-dropdown': SearchSelectDropdown,
        'form-render': () => import('@/components/learing-registry/field-render/field-render.vue'),
        'partner-index-form': () => import('../partner-index-form/partner-index-form.vue'),
        'navigator-index-form': () => import('../navigator-search-index/navigator-search-index.vue'),
    },
})

export default class DataInFormTool extends Vue {

    private get formFields() {
        const toolFormLoader = this.toolFormLoader.formData;
        return toolFormLoader[this.activeToolType.key];
    }

    @Provide('validator') public $validator: any = this.$validator;

    public toolFormLoader: any = new IndexContent();

    public dataFromToolOption: any = [
        {
            text: 'Navigators Content Index API',
            value: 'NCI',
            key: 'CI',
            payload: {
                url: '/api/content/v1/ingest',
                method: 'post',
                metadata: { indexType: 'partner-index' },
            },
        },
        {
            text: 'Partners Content Index API',
            value: 'PCI',
            key: 'PCI',
            payload: {
                url: null,
                method: 'post',
                metadata: { indexType: 'navigator-index' },
            },
        },
        {
            text: 'CSV Bulk Upload',
            value: 'CSV',
            key: 'BULK_UPLOAD',
            payload: {
                url: '/upload',
                method: 'post',
                metadata: { indexType: 'upload' },
            },
        },
    ];

    public isShow: boolean = false;

    @Prop()
    private activeToolData: any;

    private dismissCountDown: number = 0;

    private isLoading: boolean = false;

    private activeToolType = this.dataFromToolOption[2];

    private toolData: any = {};

    private submitted: boolean = false;

    public onSave() {
        this.createSearchIndexConfig();
    }

    // ----------------------------------------------------------------------
    // Methods

    public fetchSearchIndexConfig() {
        const activeToolData = this.activeToolData;
        this.activeToolType.payload.publisher_id = activeToolData.id;
        const dataFromToolOption = this.dataFromToolOption;
        this.isShow = true;
        learningRegistryAPI.fetchSearchIndexConfig(activeToolData.id).then((searchConfig) => {
            if (searchConfig) {
                const metadta = searchConfig.metadata;
                const activeTab = dataFromToolOption.find(
                    (item: any) => item.payload.metadata.indexType === metadta.indexType);
                if (activeTab) {
                    this.activeToolType = activeTab;
                }
                this.activeToolType.payload = searchConfig;
            }
            this.isShow = false;
        });
    }

    public createSearchIndexConfig() {
        this.isLoading = true;
        const activeToolType = this.activeToolType;
        const activeToolData = this.activeToolData;
        activeToolType.payload.publisher_id = activeToolData.id;
        learningRegistryAPI.createSearchIndexConfig(activeToolType.payload).then(() => {
            this.dismissCountDown = 5;
            this.isLoading = false;
        });
    }

    // ----------------------------------------------------------------------
    // Hooks

    private created() {
        this.fetchSearchIndexConfig();
    }


    // ----------------------------------------------------------------------
    // Actions

    private onSelectToolType(type: any) {
        this.activeToolType = type;
        this.submitted = false;
    }

}
